import { uniqueById } from '../helpers';

export default function insightSets(state = [], action) {
  switch(action.type) {
    case 'UPDATE_GLOBAL_INSIGHTSETS':
      return uniqueById(action.insightSets);

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/insightSets.js